module.exports = __webpack_public_path__ + "img/calc.a5a49a54.svg";